import {Map, List, OrderedMap} from 'immutable';
import {getDomain} from 'shared/domainUtils';
import {getCookie} from 'cookie-utils';

import * as DisplayMode from 'constants/DisplayMode';
import * as ConnectionStatus from 'constants/ConnectionStatus';
import * as RepositoryState from 'constants/RepositoryState';

export default function () {
    const providedInitialState = window.__INITIAL_STATE__;
    const languageId = Number(localStorage.getItem('languageId') || providedInitialState.languageId || parseInt(getCookie('languageId')) || 1);
    const countryCode = providedInitialState.countryCode || 'KZ';

    return {
        routing: undefined,
        application: Map({
            connectionStatus: ConnectionStatus.CONNECTED,
            languageId,
            countryCode,
            menu: new Map({
                sports: new Map(),
                leagues: new Map()
            }),
            preMatch: new Map({
                sports: new Map(),
                leagues: new Map(),
                matches: new Map(),
                groups: new Map(),
                outcomes: new Map(),
                rates: new Map(),
                valid: true
            }),
            live: new Map({
                sports: new Map(),
                leagues: new Map(),
                matches: new Map(),
                scores: new Map(),
                groups: new Map(),
                outcomes: new Map(),
                rates: new Map(),
                valid: true,
                state: RepositoryState.NOT_INITED,
                showLineNumbers: false,
                version: 0
            }),
            stakeOfTheDay: new Map({
                sports: new Map(),
                leagues: new Map(),
                matches: new Map(),
                scores: new Map(),
                groups: new Map(),
                outcomes: new Map(),
                rates: new Map(),
                valid: true
            }),
            popularMatches: new Map({
                sports: new Map(),
                leagues: new Map(),
                matches: new Map(),
                scores: new Map(),
                groups: new Map(),
                outcomes: new Map(),
                rates: new Map(),
                valid: true
            }),
            timetable: new Map({
                sports: new Map(),
                leagues: new Map(),
                matches: new Map(),
                valid: true,
                state: RepositoryState.NOT_INITED,
                version: 0
            }),
            displayMode: {
                type: DisplayMode.ALL
            },
            bettingMode: new Map(),
            coupon: new Map({
                betSlips: new OrderedMap(),
                betTypes: new List(),
                currentBetTypeIndex: undefined,
                currentBetTypeSelected: false,
                state: undefined,
                amount: 0,
                betSlipAmounts: new Map(),
                freebet: undefined,
                isFreebet: new Map()
            }),
            betHistory: new Map(),
            news: [],
            messages: new Map({newMessagesCount: undefined}),
            userGridSelection: new Map({
                main: new Map({
                    sportsExpanded: new List()
                }),
                preMatch: new Map({
                    sportsExpanded: new List(),
                    leaguesExpanded: new List(),
                    matchesExpanded: new List(),
                    lastShown: null
                }),
                live: new Map({
                    sportsExpanded: new List(),
                    leaguesExpanded: new List(),
                    matchesExpanded: new List(),
                    lastShown: null
                })
            }),
            userGridStorable: false,
            bettingAvailable: true,
            stream: {
                openStream: false,
                matchId: undefined,
                src: undefined
            }
        }),
        betGames: Map({
            token: undefined,
            fetching: false
        }),
        promoCode: {
            error: undefined
        },
        domain: getDomain(window.location.host)
    };
}



// WEBPACK FOOTER //
// ./js/sport-betting/loadInitialState.js